module.exports = __webpack_public_path__ + "img/GDPR.0a1e76fa.png";